import { render } from "./Subnav.vue?vue&type=template&id=0ff825ae"
import script from "./Subnav.vue?vue&type=script&lang=js"
export * from "./Subnav.vue?vue&type=script&lang=js"

import "./Subnav.vue?vue&type=style&index=0&id=0ff825ae&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__